import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Necessidade Nutricional",
  path: "/merenda/mernecessidade",
  name: "mernecessidade",
  component: () => import("@/views/merenda/mernecessidade/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.NECESSIDADEDIARIANOVO_MENU_1000200199],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Necessidade Nutricional",
  path: "/merenda/mernecessidade/cadastro/:id?",
  parent: "mernecessidade",
  name: "mernecessidade_create",
  component: () => import("@/views/merenda/mernecessidade/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.NECESSIDADEDIARIANOVO_MENU_1000200199],
  },
  goesToMenu: true,
 },
];
